module.exports = __webpack_public_path__ + "static/img/product-list-03.c745581.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product-list-03.png
// module id = Nd1q
// module chunks = 1